export default {
      id: "Icon--taxonomy-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--taxonomy",
      toString: function () {
        return this.url;
      }
    }